<!-- service burner based -->
<app-feature-details-grid *ngIf="serviceBurnerBased | ready as feature">
  <app-feature-list-container>
    <h2 class="flex-auto">
      {{ '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.BURNER_BASED' | translate }}
    </h2>
    <app-feature-list-item
      data-at-last-maintenance
      *ngIf="feature | featureValue: featurePropertyKey.lastService as lastMaintenance"
      [label]="
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.LAST_MAINTENANCE.LABEL' | translate
      "
      [value]="lastMaintenance | date: 'short' | dash"
      [attr.data-feature]="'last_Maintance'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      data-at-next-maintenance
      *ngIf="feature | featureValue: featurePropertyKey.nextService as nextMaintenance"
      [label]="
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.LABEL' | translate
      "
      [value]="nextMaintenance | dateDiffMonths"
      [attr.data-feature]="'next_Maintenance'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      *ngIf="
        (feature | featureValue: featurePropertyKey.serviceIntervalBurnerHours) ||
        (feature | featureValue: featurePropertyKey.serviceIntervalBurnerHours) === 0
      "
      data-at-burner-hours
      label="{{
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.BURNER_HOURS_SINCE_LAST_MAINTENANCE.LABEL'
          | translate
      }}"
      [value]="feature | featureValue: featurePropertyKey.serviceIntervalBurnerHours"
      [attr.data-feature]="'serviceIntervalBurnerHours'"
      suffix="{{ 'GENERAL.TIME_DATE.HOURS' | translate }}"
      [editable]="serviceBurnerBased | executable: featureCommands.setHourInterval"
      (edit)="openEditModal()"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>

<!-- service time based -->
<app-feature-details-grid *ngIf="serviceTimeBased$ | async | ready as feature">
  <app-feature-list-container>
    <h2 class="flex-auto">
      {{ '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.TIME_BASED' | translate }}
    </h2>
    <app-feature-list-item
      data-at-last-maintenance
      *ngIf="feature | featureValue: featurePropertyKey.lastService as lastMaintenance"
      [label]="
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.LAST_MAINTENANCE.LABEL' | translate
      "
      [value]="lastMaintenance | date: 'short' | dash"
      [attr.data-feature]="'last_Maintenance'"
    >
    </app-feature-list-item>
    <app-feature-list-item
      data-at-next-maintenance
      *ngIf="feature | featureValue: featurePropertyKey.nextService as nextMaintenance"
      [label]="
        '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.NEXT_MAINTENANCE.LABEL' | translate
      "
      [value]="nextMaintenance | dateDiffMonths"
      [attr.data-feature]="'next_Maintenance'"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>
